import { apiClient } from './config';

export const getUserProfle = async () => {
  const { data } = await apiClient.get(`user-profiles/me`);
  return data;
};
